export const loadPurchaseTrackingData =
  () =>
  (dispatch, getState, { api }) =>
    // Get pending purchase data.
    api.getPendingDataLayerRequests().then(
      async (data) => {
        // If data is an array then we have the products.
        // Otherwise it has the form of { result: null, metadata: { ... }}
        if (Array.isArray(data)) {
          if (data.length > 0) {
            // Mark pending purchase data as sent.
            // await as we want to ensure session is not cleared before (clearCustomer)
            await api.markPendingDataLayerRequestsSent();

            return {
              isDone: true,
              data,
            };
            // No products. Need to retry.
          } else {
            return {
              isDone: false,
            };
          }
        }

        // Error. No need to retry.
        return {
          isDone: true,
        };
      },
      // Error. No need to retry.
      () => ({ isDone: true }),
    );
